import type { CameraTrack } from "../types";

export const STUDIO_PREVIEW_SNAPSHOT_KEY = 'vb:studio:preview:snapshot:v1';

export type StudioPreviewSnapshotV1 = {
  version: 1;
  createdAt: number;
  documentName?: string;
  canvas: { width: number; height: number };
  elements: any[];
  cameraTrack?: CameraTrack;
  timeline: {
    assets: any[];
    clips: any[];
    tracks: any[];
    playhead: number;
    loopPlayback?: boolean;
    loopRegion?: { start: number; end: number } | null;
    masterMuted?: boolean;
    keyframes?: any[];
    transitions?: any[];
    effectRegions?: any[];
    fxBlocks?: any[];
  };
};

export function writeStudioPreviewSnapshot(snapshot: StudioPreviewSnapshotV1): void {
  try {
    window.localStorage.setItem(STUDIO_PREVIEW_SNAPSHOT_KEY, JSON.stringify(snapshot));
  } catch (err) {
    console.warn('[previewSnapshot] Failed to write snapshot:', err);
  }
}

export function readStudioPreviewSnapshot(): StudioPreviewSnapshotV1 | null {
  try {
    const raw = window.localStorage.getItem(STUDIO_PREVIEW_SNAPSHOT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StudioPreviewSnapshotV1;
    if (!parsed || typeof parsed !== 'object') return null;
    if (parsed.version !== 1) return null;
    if (!parsed.canvas || typeof parsed.canvas.width !== 'number' || typeof parsed.canvas.height !== 'number') return null;
    if (!Array.isArray(parsed.elements)) return null;
    if (!parsed.timeline || !Array.isArray(parsed.timeline.assets) || !Array.isArray(parsed.timeline.clips) || !Array.isArray(parsed.timeline.tracks)) {
      return null;
    }
    if (parsed.timeline.keyframes != null && !Array.isArray(parsed.timeline.keyframes)) return null;
    if (parsed.timeline.transitions != null && !Array.isArray(parsed.timeline.transitions)) return null;
    if (parsed.timeline.effectRegions != null && !Array.isArray(parsed.timeline.effectRegions)) return null;
    if (parsed.timeline.fxBlocks != null && !Array.isArray(parsed.timeline.fxBlocks)) return null;
    return parsed;
  } catch (err) {
    console.warn('[previewSnapshot] Failed to read snapshot:', err);
    return null;
  }
}
